const NON_SAFARI_MARKERS = [
  'crios',
  'fxios',
  'edgios',
  'opios',
  'micromessenger',
  'qq/',
  'qqbrowser',
  'huaweibrowser',
  'miuibrowser',
  'ucbrowser',
  'samsungbrowser',
]

export function isSafariBrowser() {
  const ua = (navigator.userAgent || '').toLowerCase()
  const vendor = (navigator.vendor || '').toLowerCase()

  if (!ua.includes('safari')) {
    return false
  }

  if (!vendor.includes('apple')) {
    return false
  }

  return !NON_SAFARI_MARKERS.some(marker => ua.includes(marker))
}

export function createBrowserDeviceId() {
  const screenInfo = window.screen || {}
  const fingerprint = [
    navigator.userAgent || '',
    navigator.platform || '',
    navigator.language || '',
    navigator.hardwareConcurrency || '',
    navigator.maxTouchPoints || '',
    screenInfo.width || '',
    screenInfo.height || '',
    screenInfo.colorDepth || '',
    Intl.DateTimeFormat().resolvedOptions().timeZone || '',
  ].join('|')

  const hashPart = seed => {
    let hash = seed
    for (let index = 0; index < fingerprint.length; index += 1) {
      hash = (hash * 31 + fingerprint.charCodeAt(index)) % 4294967291
    }
    return Math.floor(hash).toString(16).padStart(8, '0').slice(-8)
  }

  return `IPHONE-${[17, 37, 97].map(hashPart).join('').toUpperCase()}`
}
